import { Injector } from '@angular/core';
import { AbstractDragHandler } from '../../cross-team-shared/annotation/shared/tool-helpers/abstract-drag-handler';
import {
  CameraOperationType,
  MainCameraService,
} from '../render/cameras/main-camera.service';
import { MainPointCloudRendererCursorService } from '../renderers/main-point-cloud/main-point-cloud-renderer-cursor.service';

export class CameraControlDragHandler extends AbstractDragHandler {
  private cameraOperation: CameraOperationType | undefined;
  private dragHappened = false;
  private mainCameraService: MainCameraService;
  private mainPointCloudRendererCursorService: MainPointCloudRendererCursorService;

  constructor(initialEvent: MouseEvent, injector: Injector) {
    super(initialEvent, injector);

    this.mainCameraService = injector.get(MainCameraService);
    this.mainPointCloudRendererCursorService = injector.get(
      MainPointCloudRendererCursorService,
    );
    this.cameraOperation = this.computeCameraOperation();

    this.mainPointCloudRendererCursorService.draggingStatus$.next('waiting');

    this.handleMouseEvent();

    void this.completion.then(() =>
      this.mainPointCloudRendererCursorService.draggingStatus$.next(
        'completed',
      ),
    );
  }

  protected onMouseMove(event: MouseEvent) {
    if (!this.cameraOperation) {
      return;
    }

    if (this.cameraOperation === 'rotate') {
      this.mainPointCloudRendererCursorService.draggingStatus$.next('rotating');
    } else if (this.cameraOperation === 'pan') {
      this.mainPointCloudRendererCursorService.draggingStatus$.next('panning');
    }

    this.dragHappened = true;
    this.mainCameraService.controls.onMouseMove(event);
    this.mainCameraService.controls.update();
    this.mainCameraService.onDragOrMouseUp(this.cameraOperation);
  }

  protected override onMouseUp(event: MouseEvent) {
    if (this.cameraOperation && this.dragHappened) {
      this.mainCameraService.controls.onMouseUp(event);
      this.mainCameraService.onDragOrMouseUp(this.cameraOperation);
    }
  }

  private computeCameraOperation() {
    const event = this.initialEvent;

    if (event.button === 2 && event.shiftKey) {
      return 'rotate';
    } else if (event.button === 1) {
      return 'rotate';
    } else if (event.button === 2) {
      return 'pan';
    }
    return undefined;
  }

  private handleMouseEvent() {
    const { controls } = this.mainCameraService;
    switch (this.cameraOperation) {
      case 'rotate':
        controls.handleRotationStart(this.initialEvent);
        break;
      case 'pan':
        controls.handlePanStart(this.initialEvent);
        break;
    }
  }
}
